import { UtmCampaign } from 'app/src/components/CrossFlowProvider';
import { SharedState } from '@trello/shared-state';

export interface OverlayContext {
  orgId?: string;
  source?: string;
  campaign?: UtmCampaign;
  redirect?: boolean;
}

export interface OverlayState {
  overlayType: 'plan-selection' | null;
  context: OverlayContext;
}

// Reducer
const initialState: OverlayState = {
  overlayType: null,
  context: {},
};

export const overlayState = new SharedState<OverlayState>(initialState);
